import { defineStore } from 'pinia'
import { setTheme, ThemeEnum } from '~/theme'
import { webSiteInfoApi } from '~/apis'
import { filterResourceDomainsByCategory } from '~/composables/useUtil'
import { fetchJson } from '~/composables/request'
import { cancelCollectApi, saveCollectApi } from '~/apis/videoDetail'
import CacheFileStore from '@/utils/CacheFileStore'
import { AdvTypeEnum, BannerTypeEnum, PositionTypeEnum } from '@/types/enumTypes'

export const useGlobalStore = defineStore('globalStore', {
  state: () => ({
    version: '1.0.0',
    showTip: false, //显示观影限制提示
    theme: 'dark' as ThemeEnum, // 默认主题
    appConfig: {} as any,
    isTest: false,
    isQuickRegister: false,
    appData: {} as any,
    isDev: process.env.NODE_ENV === 'development',
    clientApiList: [], // 客户端接口列表
    currtClientApi: '', // 当前客户端接口
    videoImageList: [], //视频封面列表
    assertApiList: [], // 资源接口列表
    advDomainList: [], // 广告域名列表
    searchDomain: [], // 搜索域名列表
    currtSearchDomain: {} as any, // 当前搜索域名
    currtAssertApi: {}, // 当前资源接口
    routeList: [], // 视频域名列表
    webSiteJsonApi: '', // 网站info json接口
    domainUrl: '', // 注册域名
    domain: '', // 客户端域名
    serverApi: '', // 服务端接口
    clklog: {}, // clklog打点统计
    jsonApi: '', // json接口
    tenantId: 3,
    webSiteId: 3,
    noticeDialog: null,
    layout: 'clo', // 视频 card 排列方式  row：每行1个card； clo：每行2个card
    curAdvDomain: '', //广告域名,
    curResourceDomain: '', // 随机视频域名
    showPlayerAdvFlag: false, //是否显示暂停广告
    curVideoImageDomain: {}, // 当前视频封面域名
    userHistoryList: [], // 未登录用户浏览记录
    userHistoryIds: [], // 未登录用户浏览记录 id集合
    userCollectList: [], // 未登录用户收藏记录
    userCollectIds: [] as any, // 未登录用户收藏记录 id集合

    userLoginedHistoryList: [], // 已登陆用户浏览记录
    userLoginedHistoryIds: [], // 已登陆用户浏览记录 id集合
    userLoginedCollectList: [] as any, // 已登陆用户收藏记录
    userLoginedCollectIds: [] as any, // 已登陆用户收藏记录 id集合

    userCollectData: [] as any,
    mutedHanndle: true, // 控制短视频静音
    showWordAnnouncement: false,
    showPicAnnouncement: false,
    showNameplateAnnouncement: false,
    qsDetailInfo: {}, // 问题反馈详情
    isPlaying: false, //是否播放中
    isStartPlay: false, //视频是否开始播放
    reallyEnd: false, //视频是否播放结束
    showProgressBar: true, //进度条是否显示
    checkProgressTime: '', //检查进度条定时器
    showControl: false, //是否显示快进
    newVideoIndex: 0, // 筛选标签状态
    resetWrapperHeight: {},
    prevRoutePath: '', // 上一个路由路径
    stayTime: '' //停留时长
  }),
  actions: {
    //记录首页停留时间
    logHomeStayTime(type = 'start') {
      if (type == 'start') {
        this.stayTime = new Date().getTime()
      } else {
        const tabId = this.appData.tabs?.find((item) => item.category == 1)?.id?.toString()
        const duration = ((new Date().getTime() - this.stayTime) / 1000).toFixed(3)
        try {
          trackEvent({
            type: 'clklog',
            category: 'TabStay',
            tabId,
            duration
          })
        } catch (error) {
          console.log(error)
        }
      }
    },
    async toggleCollect(id = '', showTip?: boolean) {
      const authStore = useAuthStore()
      const { isAuthenticated } = storeToRefs(authStore)
      const { vDetail } = storeToRefs(useVideoDetailStore())
      if (this.userCollectData.includes(id)) {
        let idx = this.userCollectData.indexOf(id)
        if (isAuthenticated.value) {
          this.userLoginedCollectList.splice(idx, 1)
          this.userLoginedCollectIds = this.userLoginedCollectIds.filter((item: string) => item !== id)
          const res: any = await cancelCollectApi({ videoId: id })
          if (res.code == 200 && showTip) {
            showToast('已取消收藏')
          }
        } else {
          this.userCollectIds = this.userCollectIds.filter((item: string) => item !== id)
          this.userCollectList.splice(idx, 1)
        }
        // console.log('idxidxidxidx:', idx)
        this.userCollectData.splice(idx, 1)
      } else {
        if (isAuthenticated.value) {
          const res: any = await saveCollectApi({ videoId: id, isIU: true })
          this.userLoginedCollectIds = [id, ...this.userLoginedCollectIds]
          this.userLoginedCollectList = [vDetail.value, ...this.userLoginedCollectList]
          if (res.code == 200 && showTip) {
            showToast('已加入收藏')
          }
        } else {
          this.userCollectIds = [id, ...this.userCollectIds]
          this.userCollectList = [vDetail.value, ...this.userCollectList]
        }
        this.userCollectData = [id, ...this.userCollectIds]
      }
    },

    toggleTheme() {
      this.theme = this.theme === ThemeEnum.dark ? ThemeEnum.light : ThemeEnum.dark
      this.setThemeClass()
    },
    initToggleTheme() {
      this.theme = ThemeEnum.dark // 切换主题
      this.setThemeClass()
    },
    // initToggleTheme() {
    //   this.theme = ThemeEnum.dark // 切换主题
    //   this.setThemeClass()
    // },
    setThemeClass(theme?: ThemeEnum) {
      setTheme(theme || this.theme)
    },
    // 获取本地temp大规模json文件
    getDemoAlltag() {
      return new Promise(async (res, rej) => {
        if (import.meta.env.MODE == 'development') {
          let test = await fetchJson('/temp/allTag.json')
          res(test)
        } else {
          res(null)
        }
      })
    },
    async getHomeJsonAction() {
      this.updateStoreFromConfig(this.appConfig)
      const configStore = useConfigStore()

      configStore.jsonData.param = `/media-json/${this.tenantId}/${this.webSiteId}/home/home.json`
      const data = await fetchJson(`${this.jsonApi}/pages/${this.tenantId}/${this.webSiteId}/new/home.json`)
      data.resourceDomains = this.appConfig.resourceDomains
      //获取广告数据
      const adData = await fetchJson(`${this.jsonApi}/pages/${this.tenantId}/${this.webSiteId}/new/adv.json`)
      data.advList = adData.advList || []
      data.tabs?.forEach((item) => {
        const tabAd = adData.tabs?.find((t) => t.id == item.id) || []
        item.advList = tabAd.advList
      })
      try {
        // data.allTags = await this.getDemoAlltag(); //线上json数据保存本地，全部标签性能测试
        if (this.appConfig.identifies != 'gay') {
          if (!data.allTags || !data.allTags.length) {
            data.allTags = await fetchJson(`${this.jsonApi}/pages/tag/allTag.json`)
          }
        }
      } catch (e) {}

      if (this.appConfig.identifies == 'gay') {
        data.hotTags = await fetchJson(`${this.jsonApi}/pages/tag/gayHotTag.json`)
      } else {
        data.hotTags = await fetchJson(`${this.jsonApi}/pages/tag/hotTag.json`)
      }

      this.appData = data
      //获取常用外链
      const linkData = await fetchJson(`${this.jsonApi}/pages/${this.tenantId}/${this.webSiteId}/new/externalLink.json`)
      Object.assign(this.appData, linkData)
      // clklog 配置
      if (this.appData?.externalLink?.[0]?.clk) {
        this.clklog = adaptToJsonFormat(this.appData?.externalLink?.[0]?.clk)
      }
      this.appConfig.feedbackOpen = this.appData.feedbackOpen
      await this.setCacheFile()
      return this.appData
    },
    async setCacheFile() {
      const externalLinkObj = this.appData?.externalLink?.[0]
      const { userInfo }: any = storeToRefs(useAuthStore())
      const cacheObj = {
        id: `${this.tenantId}-${this.webSiteId}`,
        tenantId: this.tenantId,
        webSiteId: this.webSiteId,
        apiDomains: this.clientApiList.map((item) => item.url),
        jsonDomains: externalLinkObj?.spareDomainUrl?.split(',') || [
          'https://ewfwefgxptgy6.qyzyhb.com',
          'https://ewfwefgxptgy7.qyzyhb.com'
        ],
        mockApiDomains: externalLinkObj?.mockApiDomainUrl?.split(',') || [
          'https://671a1f32acf9aa94f6a93cc2.mockapi.io'
        ],
        qq: externalLinkObj?.qqGroup || '',
        kefu: externalLinkObj?.customerUrl || '',
        mail: externalLinkObj?.email || '',
        userId: userInfo?.value?.user_id || '',
        deviceId: '',
        preventLossUrl: externalLinkObj?.preventLossUrl || ''
      }
      console.log('缓存文件内容', cacheObj)
      // 传递给安卓api参数
      if (window?.android?.logReportApi) {
        window?.android?.logReportApi(JSON.stringify(cacheObj))
        console.log('传递给安卓api参数', cacheObj)
      }
      const store = new CacheFileStore('domain-cache')
      await store.putJSON('data.json', cacheObj, {})
    },
    //服务端
    async getAppConfigAction() {
      try {
        let param = {
          domain: this.domain
        }
        // 测试环境
        if (this.isDev) {
          const devUrl = process.env.DEV_DOMAIN as string
          // console.log('devUrl:', devUrl)
          param.domain = devUrl
          this.domain = devUrl
        }
        const configStore = useConfigStore()

        const {
          public: { custom }
        } = useRuntimeConfig()
        // 如果是测试环境 或者没有json域名
        let res: any = await webSiteInfoApi(param, custom.webSiteJsonApi)

        const seen = []
        //测试环境请求info.json失败添加
        function replacer(key, value) {
          if (typeof value === 'object' && value !== null) {
            if (seen.indexOf(value) !== -1) {
              return // 返回 undefined 来忽略循环引用
            }
            seen.push(value)
          }
          return value
        }
        let domain = cleanDomain(this.domain) || 'test.mediaclient-gay.dfre45.com'
        domain = domain.replace('http://', '')
        this.appConfig = cryptoAES.decryptJson(res.data.value) || {}
        this.webSiteId = this.appConfig.webSiteId
        this.tenantId = this.appConfig.tenantId
        configStore.first.param = {
          jsonApi: `${custom.webSiteJsonApi}/pages/new/${domain}/info.json`,
          domain: this.domain,
          webSiteJsonApi: custom.webSiteJsonApi,
          res: JSON.stringify(this.appConfig, replacer)
        }

        //获取资源域名
        const resourceDomainsUrl = `${custom.webSiteJsonApi}/pages/${this.tenantId}/${this.webSiteId}/new/resourceDomains.json`
        const resourceRes = await fetchJson(resourceDomainsUrl)
        this.appConfig.resourceDomains = resourceRes
        configStore.second.param = {
          jsonApi: `${custom.webSiteJsonApi}/pages/${this.tenantId}/${this.webSiteId}/new/resourceDomains.json`,
          res: JSON.stringify(this.appConfig.resourceDomains, replacer)
        }
        //获取站点信息
        const siteUrl = `${custom.webSiteJsonApi}/pages/${this.tenantId}/${this.webSiteId}/${this.appConfig.sourceId}/new/site.json`
        const siteData = await fetchJson(siteUrl)
        configStore.third.param = {
          jsonApi: `${custom.webSiteJsonApi}/pages/${this.tenantId}/${this.webSiteId}/${this.appConfig.sourceId}/new/site.json`,
          res: JSON.stringify(siteData, replacer)
        }
        Object.assign(this.appConfig, siteData)
        this.updateStoreFromConfig(this.appConfig)
        this.getTemplateClassFn()
        if (this.appConfig.identifies == 'gay') {
          this.theme = ThemeEnum.light // 切换主题
        }
      } catch (error) {
        console.error('getAppConfigAction2 error:', error)
      }
    },
    //客户端
    async getAppConfigWebAction() {
      try {
        //获取资源域名
        const resourceDomainsUrl = `${this.jsonApi}/pages/${this.tenantId}/${this.webSiteId}/new/resourceDomains.json`
        const resourceRes = await fetchJson(resourceDomainsUrl)
        this.appConfig.resourceDomains = resourceRes
        this.updateStoreFromConfig(this.appConfig)
        let domain = cleanDomain(import.meta.dev ? this.domain : window?.location?.origin)
        if (domain) {
          const configUrl = `${this.jsonApi}/pages/new/${domain}/info.json`
          const res = await fetchJson(configUrl)
          if (res && res.webSiteId) {
            Object.assign(this.appConfig, res)
            this.webSiteId = res.webSiteId
            this.tenantId = res.tenantId
          }
        }
        //获取站点信息
        const siteUrl = `${this.jsonApi}/pages/${this.tenantId}/${this.webSiteId}/${this.appConfig.sourceId}/new/site.json`
        const siteData = await fetchJson(siteUrl)
        Object.assign(this.appConfig, siteData)
        if (this.appConfig.identifies == 'gay') {
          this.theme = ThemeEnum.light // 切换主题
        }
        this.getTemplateClassFn()
        this.setThemeClass()
      } catch (error) {
        console.log('getAppConfigWebAction error:', error)
      }
    },

    updateStoreFromConfig(appConfig: any) {
      this.advDomainList = filterResourceDomainsByCategory(1)
      this.routeList = filterResourceDomainsByCategory(2)
      this.assertApiList = filterResourceDomainsByCategory(3)
      this.videoImageList = filterResourceDomainsByCategory(6)
      this.clientApiList = filterResourceDomainsByCategory(4)
      this.searchDomainList = filterResourceDomainsByCategory(8)

      const domainList = filterResourceDomainsByCategory(9)
      let jsonApiIdx = useRandom(0, domainList.length - 1)
      this.jsonApi = domainList[jsonApiIdx]?.url + '/oss'
      this.appConfig.transMediaDomain = this.jsonApi

      // 随机静态资源域名
      let advIdx = 0
      if (this.assertApiList.length > 0) {
        advIdx = useRandom(0, this.assertApiList.length - 1)
      }
      // 随机搜索域名
      if (this.searchDomainList.length > 0) {
        const ranIdx = useRandom(0, this.searchDomainList.length - 1)
        this.currtSearchDomain = this.searchDomainList[ranIdx]
      }
      if (process.client) {
        // @ts-ignore
        this.currtAssertApi = this.assertApiList[advIdx]?.url || window.location.origin
        window.currtAssertApi = this.currtAssertApi
      }
    },
    setWordAnnouncement(value: boolean) {
      this.showWordAnnouncement = value
    },
    setPicAnnouncement(value: boolean) {
      this.showPicAnnouncement = value
    },
    setNameplateAnnouncement(value: boolean) {
      this.showNameplateAnnouncement = value
    },
    getTemplateClassFn() {
      let className = ''
      if (this.appConfig.identifies == 'gay') {
        className = 'nantong'
      } else {
        className = this.appConfig.identifies
      }
      this.appConfig.getTemplateClass = className
      if (process.client) {
        document.body?.classList?.add(className)
      }
    }
  },
  getters: {
    currentTheme: (state) => state.theme, // 计算属性获取当前主题
    isNanTong: (state) => state.appConfig.identifies == 'gay',
    //间隔广告-横幅广告
    sponsorObj: (state) =>
      state.appData?.advList?.[AdvTypeEnum.SPONSOR_ADV]?.[PositionTypeEnum.TOP]?.[BannerTypeEnum.BANNER]?.[0] || {},
    //间隔广告-集群广告
    sponsorCluster: (state) =>
      state.appData?.advList?.[AdvTypeEnum.SPONSOR_ADV]?.[PositionTypeEnum.TOP]?.[BannerTypeEnum.CLUSTER] || []
  }
})
